module.exports = __webpack_public_path__ + "static/img/erm.119dff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erm.png
// module id = 2JcL
// module chunks = 1